import {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';
import {DictionaryTree} from 'src/openapi/admin/models/DictionaryTree';

type GetAllActionTypes = (tree: DictionaryTree[]) => DictionaryItem[];
export const getAllActionTypes: GetAllActionTypes = tree => (
    tree.reduce((acc, curr) => [
        ...acc,
        ...curr.children
            ? curr.children.map(({id, description}) => ({code: id, description}) as DictionaryItem)
            : [],
    ], [] as DictionaryItem[])
);

type GetFilteredActionTypes = (tree: DictionaryTree[], categories: string[]) => DictionaryItem[];
export const getFilteredActionTypes: GetFilteredActionTypes = (tree, categories) => (
    tree.reduce((acc, curr) => {
        if (categories.includes(curr.id)) {
            return [
                ...acc,
                ...curr.children
                    ? curr.children.map(({id, description}) => ({code: id, description}) as DictionaryItem)
                    : [],
            ];
        } else {
            return acc;
        }
    }, [] as DictionaryItem[])
);

type GetAllCategories = (tree: DictionaryTree[]) => DictionaryItem[];
export const getAllCategories: GetAllCategories = (tree: DictionaryTree[]) => (
    tree.map(category => ({
        code: category.id,
        description: category.description,
    }))
);

type GetFilteredCategories = (tree: DictionaryTree[], actionTypeCode: string) => DictionaryItem[];
export const getFilteredCategories: GetFilteredCategories = (tree, actionType) => {
    const matchedCategory = tree.find(({children}) => (
        children
            ? children.some(child => child.id === actionType)
            : false
    ));

    if (matchedCategory) {
        return [{code: matchedCategory.id, description: matchedCategory.description}];
    }

    return [];
};
